import { RequestConfig } from '~/common/services/requests';
import { FormContext } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationFormContext = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Record<string, FormContext>> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/form/context`, {
    params,
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
    },
  });
